const getInfo = state => state.lead.seekerInfo.publisher;
const getPosting = state => state.lead.seekerInfo.posting;
const getPublisher = state => state.lead.seekerInfo.publisher;
const getinfoLoading = state => state.lead.seekerInfo.loading;
export { getInfo, getPosting, getinfoLoading, getPublisher };
